/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect } from 'react'
import { useHookstate } from '@hookstate/core'
import Layout from '~/components/Layout'
import { useLang } from '~/hooks/useLang'
import CrudIndex from '~/components/CrudIndex'
import ViewMore from '../components/ViewMore'
import userUserState from '~/features/User/stores/UserState'

// no types required since results are not rendered here
export default function Index() {
  const { translate } = useLang()
  const { verifyPermission } = userUserState()
  const showCreateButton = useHookstate<boolean>(true)
  const name = useHookstate<string | null>(null)
  const agencyId = useHookstate<number | null>(null)
  const active = useHookstate<boolean | null>(null)
  const forceRefresh = useHookstate(false)

  useEffect(() => {
    document.title = translate('Resources - Dispatch System')
  }, [])

  return (
    <Layout marginLayout={true}>
      <CrudIndex
        model='warehouse'
        title='Warehouses'
        aliasLabel={[
          { column: 'agency:acronym', label: 'Agency:name' },
          { column: 'created_at', label: 'Criado em' },
          { column: 'is_active', label: 'Ativo' },
        ]}
        booleanField={['is_active']}
        exceptColumns={[]}
        notSortable={['agency:acronym', 'is_active', 'created_at']}
        forceOrderColumns={['name', 'agency:acronym', 'is_active', 'created_at']}
        filters={[
          { name: 'name', type: 'name', variable: name },
          { name: 'agency_id', type: 'agency_id', variable: agencyId },
          { name: 'is_active', type: 'boolean', variable: active },
        ]}
        datesField={['created_at']}
        showCreateButton={true}
        desableDelete={false}
        editable={true}
        canView={true}
        rowActionDisabled={(row) => !row.hasAccess}
        viewTitle={'Warehouse Details'}
        showInViewMore={['name', 'agency:name', 'is_active', 'created_at']}
        customViewMoreComponent={ViewMore}
        clearFilters={() => {
          name.set(null)
          agencyId.set(null)
          active.set(null)
          forceRefresh.set(!forceRefresh.get())
        }}
        searchButton={() => forceRefresh.set(!forceRefresh.get())}
        forceRefresh={forceRefresh.get()}
        disableColumnsFilters
      />
    </Layout>
  )
}
